module.exports = __webpack_public_path__ + "static/media/overpass-light-italic.df98f835.ttf";